import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from '../../../components/tag/Row';
import modal from '../../../definitions/Modal';
import OTButton from '../../../components/tag/OTButton';

// Row 1: FormattedMessage -> header + list
// Row 2: button

const { id: module_id } = module;
const timelineModal = modal({
  content: { width: '500px', padding: '40px 40px 30px 40px' },
});

class TimelineTopAlertModal extends React.Component {
  render() {
    let { intl, hideModal, ...rest } = this.props;
    return (
      <Modal
        {...rest}
        shouldReturnFocusAfterClose
        shouldFocusAfterRender
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        onRequestClose={hideModal}
        contentLabel=""
        style={timelineModal}
      >
        <Row>
          <h4 className={'ot-modal__title'}>
            <FormattedMessage id={`${module_id}.events.unavailable.title`} />
          </h4>
          <FormattedMessage
            id={`${module_id}.events.unavailable`}
            values={{
              ul: (chunks) => (
                <ul className="ot-timeline-modal-list">{chunks}</ul>
              ),
              li: (chunks) => <li>{chunks}</li>,
            }}
          />
        </Row>
        <Row style={{ textAlign: 'center' }}>
          <OTButton message={'back'} color={'gray'} onClick={hideModal} />
        </Row>
      </Modal>
    );
  }
}

export default connect()(injectIntl(TimelineTopAlertModal));
